import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import './MonthlyEsicWage.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
const MonthlyEsicWage = () => {
    const [monthlyESIWage, setPayment] = useState({ challanPeriod: "" });
    const [data, setData] = useState(null);
    const [isFocused, setIsFocused] = useState({ challanPeriod: false });
    const [loading, setLoading] = useState(false);

    const handleGenerateReport = async () => {
        if (!monthlyESIWage.challanPeriod) return;

        setLoading(true);
        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/esic-payment-receipt/challan-period/${monthlyESIWage.challanPeriod}`
            );
            if (!res.ok) throw new Error("Failed to fetch data");
            const json = await res.json();
            setData(json);
        } catch (err) {
            console.error(err);
            setData(null);
        } finally {
            setLoading(false);
        }
    };
    const generateExcel = async () => {
        if (!data) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("EPF Payment Confirmation Receipt");

        // Title
        worksheet.mergeCells("A1:B1");
        const titleCell = worksheet.getCell("A1");
        titleCell.value = "EPF Payment Confirmation Receipt";
        titleCell.font = { size: 16, bold: true };
        titleCell.alignment = { vertical: "middle", horizontal: "center" };

        // Add table headers
        worksheet.addRow([]);
        worksheet.addRow(["Field", "Value"]);

        Object.entries(data).forEach(([key, value]) => {
            // Format numbers
            if (typeof value === "number") value = value.toLocaleString();
            // Format dates
            if (key.toLowerCase().includes("date") && value) value = format(new Date(value), "dd-MM-yyyy");
            worksheet.addRow([key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase()), value || ""]);
        });

        // Style header row
        worksheet.getRow(2).font = { bold: true };

        // Download Excel
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `EPF_Payment_Confirmation_Receipt.xlsx`;
        link.click();
    };

    const generatePDF = () => {
        if (!data) return;

        const doc = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
        });

        const pageWidth = doc.internal.pageSize.getWidth();

        // Title
        doc.setFontSize(16);
        doc.setFont(undefined, "bold");
        doc.text("Payment Confirmation Receipt", pageWidth / 2, 15, { align: "center" });

        // Prepare table rows, excluding `id`
        const rows = Object.entries(data)
            .filter(([key]) => key !== "id")
            .map(([key, value]) => {
                if (typeof value === "number") value = value.toLocaleString();
                if (key.toLowerCase().includes("date") && value) value = format(new Date(value), "dd-MM-yyyy");
                return [
                    key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase()),
                    value || ""
                ];
            });

        doc.autoTable({
            startY: 25,
            body: rows,
            theme: 'grid',           // grid theme
            styles: {
                fontSize: 10,
                fontStyle: 'normal', // remove bold
                halign: 'left',
                valign: 'middle',
                lineColor: [0, 0, 0], // black borders
                lineWidth: 0.5        // border thickness
            },
            headStyles: {
                fillColor: [41, 128, 185],
                textColor: 255,
                fontStyle: 'normal',  // remove bold for header if needed
                lineColor: [0, 0, 0], // black header borders
                lineWidth: 0.5
            },
            columnStyles: {
                0: { cellWidth: 60 },
                1: { cellWidth: 120 }
            },
        });

        doc.save(`EPF_Payment_Confirmation_Receipt.pdf`);
    };




    return (
        <div className="monthlyESIWage-container">
            <div className="monthlyESIWage-box">
                <h2 className="monthlyESIWage-heading"> ESIC Monthly Contribution Receipt</h2>

                {/* Wage Month Picker */}
                <div className="monthlyESIWage-maincontainer">
                    <div className="monthlyESIWage-container-part">
                        <div
                            className={`monthlyESIWage-floating-label-container-2 ${isFocused.challanPeriod || !!monthlyESIWage.challanPeriod ? "float-label" : ""
                                }`}
                        >
                            <DatePicker
                                selected={
                                    monthlyESIWage.challanPeriod
                                        ? new Date(
                                            `${monthlyESIWage.challanPeriod.split("-")[1]}-${monthlyESIWage.challanPeriod.split("-")[0]}-01`
                                        )
                                        : null
                                }
                                onChange={(date) => {
                                    if (date) {
                                        const formatted = format(date, "MMM-yyyy").toUpperCase();
                                        setPayment((prev) => ({ ...prev, challanPeriod: formatted }));
                                    } else {
                                        setPayment((prev) => ({ ...prev, challanPeriod: "" }));
                                    }
                                }}
                                dateFormat="MMM-yyyy"
                                showMonthYearPicker
                                placeholderText="MMM-yyyy"
                                className="did-floating-input"
                            />
                            <label>
                                <span className="required">*</span>Challan Period
                            </label>
                        </div>
                    </div>
                </div>

                {/* Generate Report Button */}
                <div className="monthlyESIWage-btn-div">
                    {/* <button className="monthlyESIWage-clear"
                        //onClick={handleClear}
                        disabled={!monthlyESIWage.challanPeriod || loading}>
                        {loading ? "Clear..." : "Clear"}
                    </button> */}
                    <button className="monthlyESIWage-btn"
                        onClick={handleGenerateReport}
                        disabled={!monthlyESIWage.challanPeriod || loading}>
                        {loading ? "Generating..." : "Generate Report"}
                    </button>

                    <button
                        type="button"
                        className="monthlyESIWage"
                        onClick={generatePDF}
                        disabled={!data} // <-- disable button if no data
                    >
                        Download PDF
                    </button>
                </div>


            </div>

            <div className="monthlyWages-tablew">

                <div className="monthlyESIWage-div">
                    {/* <button
                        type="button"
                        className="monthlyESIWage"
                        onClick={generateExcel}
                       
                    >
                        Download Excel
                    </button> */}

                </div>
                {/* Table showing fetched data */}

                <div className="monthlyESIWage-table-container" >
                    {data ? (
                        <table className="monthlyESIWage-table">

                            <tbody>

                                <tr>
                                    <th className="wages-cell">Transaction Status</th>
                                    <td>{data.transactionStatus}</td>

                                </tr>
                                <tr>
                                    <th className="wages-cell">Employer Code No</th>
                                    <td>{data.employerCodeNo}</td>
                                </tr>

                                <tr>
                                    <th className="wages-cell">Employer Name</th>
                                   <td>{data.employerName}</td>

                                </tr>
                                <tr>
                                    <th className="wages-cell">Challan Period</th>
                                    <td>{data.challanPeriod}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell">Challan Number</th>
                                    <td>{data.challanNumber}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell">Challan Created Date</th>
                                    <td>{data.challanCreatedDate}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell">Challan Submitted Date</th>
                                    <td>{data.challanSubmittedDate}</td>

                                </tr>
                                <tr>
                                    <th className="wages-cell">Amount Paid</th>
                                    <td>{data.amountPaid}</td>
                                </tr>

                                <tr>
                                    <th className="wages-cell"> Transaction Number</th>
                                    <td>{data.transactionNumber}</td>

                                </tr>
                                <tr>
                                    <th className="wages-cell">Payment Receipt</th>
                                    <td>
                                        {data.paymentReceipt && (
                                            <a href={data.paymentReceipt} target="_blank" rel="noopener noreferrer">
                                                View File
                                            </a>
                                        )}
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    ) : (
                        <div style={{ color: "red", marginTop: "20px", fontWeight: "bold", marginLeft: "30%" }}>
                            No Data Available
                        </div>
                    )}
                </div>

            </div>
        </div>
    );
};

export default MonthlyEsicWage;
